// extracted by mini-css-extract-plugin
module.exports = {"header":"header--1jVsv","waterfullBody":"waterfullBody--2jJEu","imgItem":"imgItem--10zTC"};